import { React, useEffect } from "react";
import PageHeader from "../components/headers/PageHeader";
import TwoLineTitle from "../components/titles/TwoLineTitle";
import WhatsappBanner from "../components/banner/WhatsappBanner";

const Publications = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const publications = [
    {
      authors:
        "G.G.H.H. Prabodhana, Y.E.Y. Amarasekara, K. Pradishan, E.M.U.W.J.B. Ekanayake, and A.N.R. Weerawansha",
      title:
        "AI-enhanced Population Forecasting Models for Effective Management of Arthropod Pests: A Case Study in Haplodiploid Spider Mites (Tetranychus ludeni)",
      venue: "NSALS '26-223",
      year: "2026",
    },
    {
      authors:
        "K. Pradishan, Y.E.Y. Amarasekara, G. Prabodhana, E.M.U.W.J.B. Ekanayake, and A.N.R. Weerawansha",
      title:
        "AI-enhanced Prediction Models to Explore Reproductive Adaptations in Cluster-Living Arthropods: A Case Study in Haplodiploid Spider Mites (Tetranychus ludeni)",
      venue: "Proceedings of ICSUSL, Sabaragamuwa University of Sri Lanka",
      year: "2025",
    },
  ];

  return (
    <div>
      <PageHeader heading="Publications" />

      <TwoLineTitle
        des="A list of my research publications and academic contributions."
        main="Publications"
      />

      <div className="flex justify-center px-[5%] md:px-[10%] pb-16">
        <div className="w-full max-w-[1140px] flex flex-col divide-y divide-gray-200">
          {publications.map((pub, i) => (
            <div key={i} className="py-6 first:pt-0">
              <h3 className="text-lg md:text-xl font-semibold text-[#002147] leading-snug">
                {pub.title}
              </h3>
              <p className="mt-2 text-sm md:text-base text-[#374151]">
                {pub.authors}
              </p>
              <p className="mt-1 text-sm md:text-base italic text-[#6B7280]">
                {pub.venue}, {pub.year}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className="flex justify-center pb-8">
        <WhatsappBanner />
      </div>
    </div>
  );
};

export default Publications;
